import {
  formExtensionsToWrite,
  ZObjectExtensionWrite,
} from "../extensionBindings";
import { ZWorkflowCommon } from "./ZWorkflow";
import { ZWorkflowStep } from "./ZWorkflowStep";

export type ZWorkflowStepWrite = Omit<ZWorkflowStep, "extensions"> & {
  extensions: ZObjectExtensionWrite[];
};

export type ZWorkflowWrite = Omit<ZWorkflowCommon, "steps"> & {
  steps?: ZWorkflowStepWrite[];
};

/**
 * Расширения шага отправляются у каждого шага: бэкенд заменяет привязки
 * шага целиком, и шаг без поля extensions остаётся без привязок
 */
export const workflowToWrite = ({
  steps,
  ...restData
}: ZWorkflowCommon): ZWorkflowWrite => ({
  ...restData,
  steps: steps?.map((step) => ({
    ...step,
    extensions: formExtensionsToWrite(step.extensions ?? []),
  })),
});
